import { render, staticRenderFns } from "./TopicApprovalRow.vue?vue&type=template&id=0a51b1dc&scoped=true&"
import script from "./TopicApprovalRow.vue?vue&type=script&lang=js&"
export * from "./TopicApprovalRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51b1dc",
  null
  
)

export default component.exports